import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import App from './App';
import ConfirmEmail from './ConfirmEmail';
import Planes from './Planes';
import CheckoutSuccess from './CheckoutSuccess';
import CheckoutCancel from './CheckoutCancel';

import AvisoLegal from './pages/AvisoLegal';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import TerminosCondiciones from './pages/TerminosCondiciones';
import PoliticaCookies from './pages/PoliticaCookies';
import RegistroExitoso from './pages/RegistroExitoso';
import ProductoAnadido from './pages/ProductoAnadido';
import LoginExitoso from './pages/LoginExitoso';
import PriceReviewAdmin from './pages/PriceReviewAdmin';
import BajaAlerta from './pages/BajaAlerta';
import Bookmarklet from './pages/Bookmarklet';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<App initialAuthIntent="login" />} />
        <Route path="/registro" element={<App initialAuthIntent="signup" />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/planes" element={<Planes />} />
        <Route path="/checkout-success" element={<CheckoutSuccess />} />
        <Route path="/checkout-cancel" element={<CheckoutCancel />} />

        {/* 👇 Esta ruta es clave para evitar conflictos con tu blog estático */}
        <Route path="/blog/*" element={<Navigate to="/blog/" replace />} />

        {/* Páginas legales */}
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
        <Route path="/politica-cookies" element={<PoliticaCookies />} />
        
        {/* Páginas de conversión para Google Ads */}
        <Route path="/registro-exitoso" element={<RegistroExitoso />} />
        <Route path="/producto-anadido" element={<ProductoAnadido />} />
        <Route path="/login-exitoso" element={<LoginExitoso />} />
        <Route path="/backend-revision-precios" element={<PriceReviewAdmin />} />
        <Route path="/baja-alerta" element={<BajaAlerta />} />
        <Route path="/boton-navegador" element={<Bookmarklet />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
